module.exports = __webpack_public_path__ + "static/media/flags.9c74e172.png";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/images/flags.png
// module id = 401
// module chunks = 0